import { PromoDetail } from "@/core/entities/promotion/PromoDetail";
import { PromoStatusTransitionType } from "@/core/enums/PromoStatusTransitionType";
import {
  getPromoDetailAtom,
  promoDetailDataAtom,
  promoDetailErrorAtom,
  promoDetailIsLoadingAtom,
  promoDetailIsTransitioningAtom,
  PromotionDrawerInfo,
  promotionDrawerInfoAtom,
  promotionIsFirstItemAtom,
  promotionIsLastItemAtom,
  promotionIsNextPrevEnabledAtom,
  putPromoStatusAtom,
  PutPromoStatusResult,
  resetPromoDetailAtom,
  setPromotionDrawerInfoAtom,
  setPromotionIsFirstItemAtom,
  setPromotionIsLastItemAtom,
  setPromotionIsNextPrevEnabledAtom,
} from "@/store/promotion";
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

interface UsePromotionDrawerResult {
  promotionDrawerInfo: PromotionDrawerInfo;
  setPromotionDrawerInfo: (promotionDrawerInfo: PromotionDrawerInfo) => void;
  promoDetail: PromoDetail | null;
  isPromoDetailLoading: boolean;
  isPromoDetailTransitioning: boolean;
  promoDetailError: Error | null;
  getPromoDetail: (refetch?: boolean) => void;
  putPromoStatus: (type: PromoStatusTransitionType) => Promise<PutPromoStatusResult>;
  resetPromoDetail: () => void;
  isFirstItem: boolean;
  isLastItem: boolean;
  isNextPrevEnabled: boolean;
  setIsFirstItem: (isFirstItem: boolean) => void;
  setIsLastItem: (isLastItem: boolean) => void;
  setIsNextPrevEnabled: (isNextPrevEnabled: boolean) => void;
}

export function usePromotionDrawer(): UsePromotionDrawerResult {
  const promotionDrawerInfo = useAtomValue(promotionDrawerInfoAtom);
  const setPromotionDrawerInfo = useSetAtom(setPromotionDrawerInfoAtom);
  const promoDetail = useAtomValue(promoDetailDataAtom);
  const isPromoDetailLoading = useAtomValue(promoDetailIsLoadingAtom);
  const isPromoDetailTransitioning = useAtomValue(promoDetailIsTransitioningAtom);
  const promoDetailError = useAtomValue(promoDetailErrorAtom);
  const getPromoDetailAction = useSetAtom(getPromoDetailAtom);
  const putPromoStatusAction = useSetAtom(putPromoStatusAtom);
  const resetPromoDetail = useSetAtom(resetPromoDetailAtom);
  const isFirstItem = useAtomValue(promotionIsFirstItemAtom);
  const isLastItem = useAtomValue(promotionIsLastItemAtom);
  const isNextPrevEnabled = useAtomValue(promotionIsNextPrevEnabledAtom);
  const setIsFirstItem = useSetAtom(setPromotionIsFirstItemAtom);
  const setIsLastItem = useSetAtom(setPromotionIsLastItemAtom);
  const setIsNextPrevEnabled = useSetAtom(setPromotionIsNextPrevEnabledAtom);
  const getPromoDetail = useCallback(
    (refetch = false) => {
      void getPromoDetailAction(refetch);
    },
    [getPromoDetailAction]
  );
  const putPromoStatus = useCallback(
    (type: PromoStatusTransitionType) => putPromoStatusAction(type),
    [putPromoStatusAction]
  );

  return {
    promotionDrawerInfo,
    setPromotionDrawerInfo,
    promoDetail,
    isPromoDetailLoading,
    isPromoDetailTransitioning,
    promoDetailError,
    getPromoDetail,
    putPromoStatus,
    resetPromoDetail,
    isFirstItem,
    isLastItem,
    isNextPrevEnabled,
    setIsFirstItem,
    setIsLastItem,
    setIsNextPrevEnabled,
  };
}
